import getImClient from "utils/imClient";
import { FetchRemoteConfigsEndpoint } from "@neard-packages/api-types/config";

export function fetchRemoteConfigs() {
  return getImClient().api.main().send(new FetchRemoteConfigsEndpoint());
}
